import * as $ from 'jquery';

import { BlockUI } from 'Core/Common/BlockUi';
import { EventArgs } from 'Core/Common/Event';
import { Guid } from 'Core/Common/Guid';
import { Notifier } from 'Core/Common/Notifier';
import { FileDownloader } from 'Core/Components/FileDownloader/FileDownloader';
import { SignalRNotificationManager } from 'Core/Components/SignalR/SignalRNotificationManager';
import { GridStore, IExportDataRequestModel } from 'Core/Controls/Grid/Stores/GridStore';

const CARD_SELECTOR = '.blockUI .export-progress';
const COUNT_SELECTOR = '.blockUI .export-progress__count';
const CANCEL_SELECTOR = '.blockUI .export-progress__cancel';

export class GridDataExporter {
    static Export(params: IExportDataRequestModel): void {
        const exportId = Guid.NewGuid();
        const signalR = SignalRNotificationManager.Instance;

        let cancelled = false;

        const stop = () => {
            signalR.Off('EXPORT_PROGRESS', GridDataExporter, onProgress);
            $(document).off('click', CANCEL_SELECTOR);
            BlockUI.Unblock();
        };

        const cancel = () => {
            cancelled = true;
            GridStore.CancelExportData({ ExportId: exportId });
            stop();
        };

        const onProgress = (eventArgs: EventArgs) =>
            GridDataExporter.ShowProgress(eventArgs.data.Exported, cancel);

        GridDataExporter.ShowProgress(0, cancel);
        signalR.On('EXPORT_PROGRESS', GridDataExporter, onProgress);

        GridStore.ExportData({ ...params, ExportId: exportId })
            .always(() => {
                if (!cancelled) {
                    stop();
                }
            })
            .then((fileName: string) => {
                if (!cancelled) {
                    FileDownloader.DownloadFile(fileName);
                }
            })
            .fail((error) => {
                if (!cancelled) {
                    new Notifier().Failed(error.message);
                }
            });
    }

    private static ShowProgress(exported: number, cancel: () => void): void {
        const count = `${exported} records`;

        if ($(CARD_SELECTOR).length) {
            $(COUNT_SELECTOR).text(count);
            return;
        }

        BlockUI.Block({
            TextOnly: true,
            TextMessage: `
                <div class="export-progress">
                    <div class="export-progress__spinner"></div>
                    <div class="export-progress__title">Exporting data</div>
                    <div class="export-progress__count">${count}</div>
                    <button type="button" data-testid="grid.export-cancel"
                            class="text-sm sps-btn sps-btn-outline export-progress__cancel">Cancel</button>
                </div>`,
        });

        $(document).off('click', CANCEL_SELECTOR).on('click', CANCEL_SELECTOR, cancel);
    }
}
